import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppService } from 'src/app/services/app-service.service';

@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss']
})
export class UserInfoComponent {
  userForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<UserInfoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private appService: AppService,
  ) {
    this.userForm = this.fb.group({
      firstName: [data.userInfo.firstName, [Validators.required, Validators.minLength(3), Validators.maxLength(15)]],
      lastName: [data.userInfo.lastName, [Validators.required, Validators.minLength(3), Validators.maxLength(15)]],
      phone: [data.userInfo.phone, [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern('^[0-9]*$')]],
    });
  }

  onSave() {
    if (this.userForm.valid) {
      // console.log(this.data.userInfo);
      const updatedUser = {
        firstName: this.userForm.get('firstName')?.value,
        lastName: this.userForm.get('lastName')?.value,
        phone: this.userForm.get('phone')?.value,
        displayName: `${this.userForm.get('firstName')?.value} ${this.userForm.get('lastName')?.value}`,
        dob: this.data.userInfo.dob,
        password: this.data.userInfo.password,
        email: this.data.userInfo.email,
        status: this.data.userInfo.status,
        occupation: this.data.userInfo.occupation,
        guid: this.data.userInfo.guid,
      };

      const userId = this.data.userInfo.id;
      // console.log('Updated User:', updatedUser);
      this.appService.updateUser(userId, updatedUser).subscribe({
        next: () => {
          this.dialogRef.close(updatedUser);
        },
        error: (err) => {
          console.error('Error updating user:', err);
          this.dialogRef.close(null);
        }
      });
    }
  }

  onCancel() {
    this.dialogRef.close();
  }
}
